module.exports = __webpack_public_path__ + "img/图文咨询.198d5517.png";